interface EventReference {
    id: string;
    name: string;
}

interface OrganizerReference {
    objectId: string;
    name: string;
    portraitBlobAddressUri: string;
}

export enum Severity {
    healthy = 0,
    warning = 1,
    unhealthy = 2,
}

export interface EquipmentIssue {
    severity: Severity;
    description: string;
    resolution: string;
}

export interface ReaderMetrics {
    date: Date;
    cpu: number;
    memory: number;
    delay: number;
    antennas: number[];
    running: boolean;
    inactivity: number;
}

export interface IReaderStationStatus {
    readerId: string;
    lastCheck: Date;
    lastSeen: Date;
    organizer?: OrganizerReference;
    trackDay?: EventReference;
    severity: Severity;
    issues: EquipmentIssue[];
}